export const APP_STATUS_OPTIONS: readonly string[] = ['active', 'suspended'];

export const APP_STATUS_LABEL: Readonly<Record<string, string>> = {
  active: 'backoffice.enums.app_status.active',
  suspended: 'backoffice.enums.app_status.suspended',
};
